
export const addDays = (date, days) => {
    const newDate = new Date(date);
    newDate.setDate(parseInt(newDate.getDate()) + parseInt(days));
    return newDate;
}

export const getYearsItemsSelect = (yearStart, yearEnd) => {
    let itemsSelectYear = [];
    for (let i = yearStart; i <= yearEnd; i++) {
        
        i = String(i);
        itemsSelectYear.push({
            item: { _id: i, name: i },
            value: i,
            label: i,
        });
    }
    itemsSelectYear = itemsSelectYear.reverse();
    return itemsSelectYear;
}
